import { signOut } from 'firebase/auth';
import { useLocation, useNavigate } from 'react-router-dom';
import { auth } from '../firebase';

const styles = {
  sidebar: {
    position: 'fixed',
    left: 0,
    top: 0,
    bottom: 0,
    width: 220,
    backgroundColor: '#0A2D5A',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 100,
  },
  sidebarLogo: {
    padding: '20px 16px',
    borderBottom: '1px solid rgba(255,255,255,0.1)',
  },
  logoText: {
    fontSize: 11,
    fontWeight: '700',
    color: 'white',
    letterSpacing: 1,
  },
  logoSub: {
    fontSize: 10,
    color: 'rgba(255,255,255,0.5)',
    marginTop: 2,
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  shieldIcon: {
    width: 36,
    height: 36,
    marginBottom: 8,
    display: 'block',
  },
  navItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 16px',
    color: 'rgba(255,255,255,0.65)',
    cursor: 'pointer',
    fontSize: 13,
    borderLeft: '2px solid transparent',
  },
  navItemActive: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 16px',
    color: 'white',
    cursor: 'pointer',
    fontSize: 13,
    borderLeft: '2px solid #E8620A',
    backgroundColor: 'rgba(255,255,255,0.08)',
  },
  logoutBtn: {
    background: 'none',
    border: 'none',
    color: 'rgba(255,255,255,0.5)',
    fontSize: 12,
    cursor: 'pointer',
    padding: '10px 16px',
    textAlign: 'left',
    marginTop: 'auto',
  },
};

const adminNavItems = [
  { label: 'Agents', path: '/admin' },
  { label: 'Send Message', path: '/admin-message' },
  { label: 'Profile', path: '/admin-profile' },
];

const navItems = [
  { label: 'Dashboard', path: '/' },
  { label: 'My Clients', path: '/clients' },
  { label: 'Add Client', path: '/add-client' },
  { label: 'Import Clients', path: '/import-clients' },
    { label: 'Send Client Links', path: '/send-client-links' },
  { label: 'Send Message', path: '/broadcast' },
  { label: 'My Profile', path: '/profile' },
  { label: 'Client Setup Guide', path: '/setup' },
];

export default function Sidebar({ admin = false }) {
  const items = admin ? adminNavItems : navItems;
  const navigate = useNavigate();
  const location = useLocation();

  const handleSignOut = async () => {
    await signOut(auth);
    navigate('/login');
  };

  return (
    <div style={styles.sidebar}>
      <div style={styles.sidebarLogo}>
        <img src="/icon.png" alt="Medicare Plan Guardian" style={styles.shieldIcon} />
        <div style={styles.logoText}>MEDICARE PLAN GUARDIAN</div>
        <div style={styles.logoSub}>Agent Portal</div>
      </div>
      <nav style={{ padding: '8px 0', flex: 1 }}>
        {items.map(item => (
          <div
            key={item.path}
            style={location.pathname === item.path ? styles.navItemActive : styles.navItem}
            onClick={() => navigate(item.path)}>
            {item.label}
          </div>
        ))}
      </nav>
      <button style={styles.logoutBtn} onClick={handleSignOut}>Sign Out</button>
    </div>
  );
}


